import { useInternalValue } from './useInternalValue';
import { useState } from 'react';

export const useModal = (showModal: boolean) => {
    const [showImportProjectModal, setShowImportProjectModal] = useInternalValue(showModal);
    const [isLoadImportProjectModal, setIsLoadImportProjectModal] = useState(false);

    const handleShowModal = () => {
        setIsLoadImportProjectModal(false);

        document.body.style.overflow = 'hidden';
        setShowImportProjectModal(true);
    };

    return {
        showImportProjectModal,
        isLoadImportProjectModal,
        handleShowModal,
        setShowImportProjectModal,
        setIsLoadImportProjectModal
    }
}